import { useEnrichIpGuide } from './useEnrichIpGuide'

export const guides = [
  {
    id: 'enrich-ip',
    title: 'Enrich IP Addresses',
    description: 'Learn how to bulk-enrich IP addresses with threat intelligence from multiple sources.',
    icon: 'crosshairs',
    category: 'Getting Started',
    route: '/enrich',
    useGuide: useEnrichIpGuide,
  },
]

export function getGuideById(id) {
  return guides.find(g => g.id === id)
}
